import React, { createContext, useContext, useState } from "react";

const UserCompanyContext = createContext();

export default function UserCompanyProvider({ children }) {
  const [userCompCode, setUserCompCode] = useState("");
  const [userCompName, setUserCompName] = useState("");

    const [userSiteCode, setUserSiteCode] = useState(null);
    const [userSiteName, setUserSiteName] = useState("");
  return (
    <UserCompanyContext.Provider value={{ userCompCode, setUserCompCode, userCompName, setUserCompName, userSiteCode, setUserSiteCode, userSiteName, setUserSiteName }}>
      {children}
    </UserCompanyContext.Provider>
  );
}

export function useUserCompany() {
  return useContext(UserCompanyContext);
}
